import { useSelector } from "react-redux";
import { RootState } from "../stores/store";
import { salesIQService } from "../services/salesIQ/salesIQ-service";

export const useSalesIQ = () => {
	const { firstName, lastName, userName, phoneNumber, countryCode } = useSelector(
		(state: RootState) => state.user
	);

	const openChat = () => {
		const name = [firstName, lastName].filter(Boolean).join(" ") || "Customer";
		const phone = countryCode && phoneNumber ? `${countryCode}${phoneNumber}` : phoneNumber;

		return salesIQService.openChat({
			name,
			email: userName ?? "",
			phone,
		});
	};

	return { openChat };
};
